orders-planner-dialog-update-status(class="{show: isShow}")
  .orders-planner-dialog-update-status.popper
    forms-orders-status(tag-scope="forms_orders_status")
    .popper__arrow(x-arrow)
  script(type="typescript").
    this.mixin('orders.planner.dialog.update-status');
  style(scoped).
    forms-orders-status inputs-complex-radio-status label.col-md-4,
    forms-orders-status inputs-submit{
      display: none;
    }
    forms-orders-status inputs-complex-radio-status .col-md-8 {
      max-width: 100% !important;
      flex: 100% !important;
    }
    forms-orders-status .form-group {
      margin-bottom: 0;
      margin-left: 0;
      margin-right: 0;
    }
